<template>
  <div>
    <!-- Items listed out -->

    <p v-if="items.length == 0">
      There are no items to delete
    </p>

    <p v-if="loading">
      Loading items...
    </p>

    <div v-if="!loading" class="flex flex-col my-4">
      <div v-for="category in categories" :key="category">
        <div class="flex flex-row">
          <p class="text-xl font-medium">{{category}}</p>
        </div>
        <div
          v-for="subCategory in subCategories[category]" :key="subCategory.name"
          v-show="filteredItems(category, subCategory.name).length > 0"
          class="pl-8"
        >
          <div class="flex flex-row">
            <p class="text-xl font-medium">{{subCategory.name}}</p>
          </div>
          <div v-for="item in filteredItems(category, subCategory.name)" :key="item.name" class="pl-8">
            <input @change="itemChange($event, item.id)" type="checkbox">
            {{item.name}}
          </div>
        </div>
      </div>
    </div>

    <general-button
      @button-click="deleteItemList()"
      :disabled="loading"
      text="Delete Items"
      color="red"
    />

  </div>

</template>

<script>
import GeneralButton from './GeneralButton.vue';
import data from '../../assets/json/data.json';

export default {
  name: 'DeleteSection',
  components: {
    GeneralButton,
  },
  data() {
    return {
      tabStates: {},
    };
  },
  props: {
    loading: {
      type: Boolean,
      required: true,
    },
    items: {
      type: Array,
      required: true,
    },
    itemsToDelete: {
      type: Array,
      required: true,
    },
  },
  computed: {
    categories() {
      return data.categories;
    },
    subCategories() {
      return data.subcategories;
    },
  },
  methods: {
    itemChange(event, curId) {
      if (event.srcElement.checked) {
        this.$emit('update:itemsToDelete', [
          ...this.itemsToDelete,
          curId,
        ]);
      } else {
        this.$emit(
          'update:itemsToDelete',
          this.itemsToDelete.filter((id) => id != curId),
        );
      }
    },
    deleteItemList() {
      this.$emit('delete-items');
    },
    filteredItems(category, subCategory) {
      return this.items.filter((item) => item.category === category && item.subCategory === subCategory);
    },
  },
};
</script>
